import { inject, observer } from "mobx-react";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import Select from "@material-ui/core/Select";

const styles = theme => ({
  wideFormControl: {
    margin: theme.spacing(1),
    minWidth: 346
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 165
  },
  rowFormControl: {
    flexDirection: "row",
    margin: theme.spacing(1),
    minWidth: 165
  }
});

class BasicOrderBy extends React.Component {
  render() {
    const { basicSearchStore, classes, precedence } = this.props;
    const sort = basicSearchStore[`${precedence}Sort`];

    return (
      <div style={{ display: "flex" }}>
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="order-by-field">Order By Field</InputLabel>
          <Select
            value={sort.fieldName}
            onChange={e => (sort.fieldName = e.target.value)}
          >
            {[
              "Timestamp",
              "PitchTime",
              "CaptivatingIndex",
              "ExitVelocity",
              "PitchSpeed",
              "HitDistance",
              "HomeTeamWPADelta",
              "AwayTeamWPADelta"
            ].map((c, i) => (
              <MenuItem key={i} value={c}>
                {c}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl className={classes.rowFormControl}>
          <FormControlLabel
            control={
              <Radio
                checked={sort.isDesc}
                onChange={e => sort.setIsDescFromValue(e.target.value)}
                value="desc"
              />
            }
            label="DESC"
          />
          <FormControlLabel
            control={
              <Radio
                checked={!sort.isDesc}
                onChange={(e, v) => sort.setIsDescFromValue(e.target.value)}
                value="asc"
              />
            }
            label="ASC"
          />
        </FormControl>
      </div>
    );
  }
}

export default inject("basicSearchStore")(
  withStyles(styles, { withTheme: true })(observer(BasicOrderBy))
);



// WEBPACK FOOTER //
// ./src/components/BasicOrderBy.js